import React from "react";
import ReactDOM from "react-dom/client";
import ChildrenEnrollment from "./features/ChildrenEnrollment";
import CompanionInviteForm from "./features/CompanionInviteForm";
import RatingForm from "./features/RatingForm";
import TrackAndTrace from "./features/TrackAndTrace";
import SalaryInsuranceCalculator from "./features/SalaryInsuranceCalculator";
import FormEnrollmentNew from "./features/FormEnrollmentNew";
import ProductCardModule from "./features/ProductCardModule";
import PersonalityTest from "./features/PersonalityTest";
import BalanceTest from "./features/BalanceTest";
import BloomreachLeadModal from "./features/BloomreachLeadModal";
import SalaryinsuranceCalculatorNew from "./features/SalaryinsuranceCalculatorNew";
import SalaryCheck from "./features/SalaryCheck"; 
import SalaryCheckResult from "./features/SalaryCheckResult";
import BehaviourAnalysis from "./features/BehaviourAnalysis";
import BehaviourAnalysisResult from "./features/BehaviourAnalysisResult";
import BehaviourAnalysisMini from "./features/BehaviourAnalysisMini";
import VismaLogbuyOffers from "./features/VismaLogbuyOffers";
import ProductBanner from "./features/ProductBanner/ProductBanner";
import ExternFormEnrollment from "./features/ExternFormEnrollment";
import SalaryinsuranceConfigCard from "./features/SalaryInsuranceConfigCard";

const widgets = [
  { app: ExternFormEnrollment, selectorName: "extern-form-enrollment" },
  { app: FormEnrollmentNew, selectorName: "form-enrollment-new" },
  { app: RatingForm, selectorName: "rating-form" },
  { app: CompanionInviteForm, selectorName: "companion-invite" },
  { app: ChildrenEnrollment, selectorName: "form-childrenEnrollment" },
  { app: TrackAndTrace, selectorName: "trackandtrace" },
  { app: SalaryInsuranceCalculator, selectorName: "salary-insurance-calculator" },
  { app: ProductCardModule, selectorName: "product-card-module" },
  { app: PersonalityTest, selectorName: "personality-test" },
  { app: BalanceTest, selectorName: "balance-test"},
  { app: BloomreachLeadModal, selectorName: "bloomreach-lead-modal" },
  { app: SalaryCheck, selectorName: "salary-check" },
  { app: SalaryCheckResult, selectorName: "salary-check-result" },
  { app: SalaryinsuranceCalculatorNew, selectorName: "salaryinsurance-calculator-new" },
  { app: BehaviourAnalysis, selectorName: "behaviour-analysis" },
  { app: BehaviourAnalysisResult, selectorName: "behaviour-analysis-result" },
  { app: VismaLogbuyOffers, selectorName: "logbuy-offers" },
  { app: ProductBanner, selectorName: "product-banner" },
  { app: SalaryinsuranceConfigCard, selectorName: "salaryinsurance-config-card" },
  { app: BehaviourAnalysisMini, selectorName: "behaviour-analysis-mini" },
];

function init() {
  widgets.forEach((widget) => {
    const nodeItems = [...document.querySelectorAll(`[data-component='${widget.selectorName}']`)] as HTMLElement[];

    nodeItems.forEach((node) => {
      const root = ReactDOM.createRoot(node);
      const App = widget.app;

      root.render(
        <React.StrictMode>
          <App/>
        </React.StrictMode>
      );
    });
  });
}

init();
